(() => {
  function bindForms(root = document) {
    root.querySelectorAll('[data-founder-form]').forEach((form) => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      const button = form.querySelector('button[type="submit"]');
      const error = form.querySelector('[data-founder-error]');
      const variantId = Number(form.elements.id.value);
      const base = form.dataset.root || '/';
      let pending = false;
      button.disabled = false;
      const validCart = (cart) => cart.currency === 'USD' && cart.items.length === 1 &&
        cart.items[0].variant_id === variantId && cart.items[0].quantity === 1 &&
        cart.items[0].properties?._founder_offer === 'founder-reservation-v1' &&
        cart.items[0].properties?.['Reservation terms'] === 'Accepted v1' &&
        !cart.items[0].requires_shipping && cart.total_price === 2500;
      const readCart = async () => {
        const response = await fetch(`${base}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error(error.dataset.generic);
        return response.json();
      };
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (pending || !form.reportValidity()) return;
        pending = true;
        button.disabled = true;
        button.textContent = button.dataset.busy;
        error.hidden = true;
        try {
          let cart = await readCart();
          if (cart.items.length && !validCart(cart)) throw new Error(error.dataset.cart);
          if (!cart.items.length) {
            const response = await fetch(`${base}cart/add.js`, {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: {
                _founder_offer: 'founder-reservation-v1',
                'Reservation terms': 'Accepted v1'
              } }] })
            });
            if (!response.ok) throw new Error(error.dataset.generic);
            cart = await readCart();
          }
          if (!validCart(cart)) throw new Error(error.dataset.price);
          try {
            window.Shopify?.analytics?.publish('founder_reservation_checkout_started', {
              offer: 'founder-reservation-v1', currency: 'USD', value: 25
            });
          } catch { /* Analytics must not block checkout. */ }
          window.location.assign(`${base}checkout`);
        } catch (failure) {
          const knownErrors = [error.dataset.generic, error.dataset.cart, error.dataset.price];
          error.textContent = knownErrors.includes(failure.message) ? failure.message : error.dataset.generic;
          error.hidden = false;
          error.focus();
          pending = false;
          button.disabled = false;
          button.textContent = button.dataset.idle;
        }
      });
    });
  }
  bindForms();
  document.addEventListener('shopify:section:load', (event) => bindForms(event.target));
})();
